import { UtilsTS } from "@/utilsts"
import { ModelSagres } from "../../model-sagres"



export class AditivoContratoResumido extends ModelSagres {
    IdAditivo: number
    NumeroAnoAditivo: string
    NumeroAnoContrato: string
    TipoAditivo: string
    NaturezaAjuste: string
    Valor: number
    DtInicioVigencia: Date
    DtFimVigencia: Date
    DtAssinatura: Date
    DtAssinaturaFormatada: string
    VigenciaFormatada: string
    ValorFormatado: string

    tratarDadosDaAPI(): void {
        if (this.DtInicioVigencia) {
            this.DtInicioVigencia = new Date(this.DtInicioVigencia)
        }

        if (this.DtFimVigencia) {
            this.DtFimVigencia = new Date(this.DtFimVigencia)
        }

        if (this.DtAssinatura) {
            this.DtAssinatura = new Date(this.DtAssinatura)
            this.DtAssinaturaFormatada = this.DtAssinatura.toLocaleDateString("pt-br")
        }

        if (this.DtInicioVigencia && this.DtFimVigencia) {
        this.VigenciaFormatada = `${this.DtInicioVigencia.toLocaleDateString("pt-br")} à ${this.DtFimVigencia.toLocaleDateString("pt-br")}`
        }
        else {
            this.VigenciaFormatada = "-"
        }

        if(this.Valor) {
            const utils = new UtilsTS()
            this.ValorFormatado = utils.formatMoeda(this.Valor)
        }
        else {
            this.ValorFormatado = "-"
        }
    }
}